<template>
    <div class="board-frame">
        <a class="anchor" id="dotJdszzc"></a>
        <div class="home-title-bt">
            <div class="home-t-bg">President Oration</div>
            <p>董事长致辞</p>
        </div>
        <div class="board-main">
            <div class="board-txt">
                <div class="boss-name wow bounceIn" data-wow-duration="1s" data-wow-delay=".4s" >
                    <img src="../../../assets/images/join/qm.png" alt="">
                </div>
                <div class="txt-yh-t" style="left: 500px;top: -96px;">
                    <img src="../../../assets/images/join/bg-bd.png" alt="">
                </div>
                <div class="txt-yh-t" style="right: -30px;bottom: -60px;">
                    <img src="../../../assets/images/join/bg-bd2.png" alt="">
                </div>
                <p class="animated wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">作为一位具有“产业+互联网”背景的企业家，我始终在思索怎样才能够助力我们的社会持续保持高质量的发展节奏。<br/><br/>
我期望百昌科技凭借“实干 ·利他”的企业价值理念，全力打造行业细分市场的平台， 成为一家真正能够“为国分忧，为民解愁”的优秀企业。</p><br/>
                <p class="animated wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" style="font-size: 16px">As an entrepreneur with an "industry+Internet"background,I have always been thinking about how to help our society maintain a high-quality devel-  opmentrhythm.I hope that Baichang Technology with the "hard work,altru- ism"enterprise value concept,to create a platform for industry segmentation market,to become a real "for the country to share the worry,for the  people to solve the worry"excellent enterprise.</p>
            </div>
            <div class="board-boss animated wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                <img class="boss-bg" src="../../../assets/images/join/boss-img.png" alt="">
                <div class="name-boss">
                    <img class="name-bg" src="../../../assets/images/join/boss-bg.png" alt="">
                    <p>百昌科技董事长<span>黄振宇</span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "board",
        mounted() {
            this.$nextTick(() => {
                new this.$wow.WOW().init();
            });
        },
    }
</script>


<style scoped lang="scss">
    .board-frame{
        position: relative;
        padding: 80px 0 0;
        height: 890px;
        .anchor{
            position: absolute;
            opacity: 0;
            top: -100px;
        }
        .board-main{
            padding-top: 158px;
            position: relative;
            .board-txt{
                padding-left: 570px;
                width: 620px;
                font-size: 17px;
                color: #333333;
                line-height: 36px;
                font-family: 'SourceHanSansCN-Regular';
                position: relative;
                p{
                    margin-bottom: 10px;
                    position: relative;
                }
                .boss-name{
                    position: absolute;
                    width: 205px;
                    height: 105px;
                    left: 930px;
                    bottom: -90px;
                    overflow: hidden;
                    img{
                        width: 205px;
                        height: 105px;
                        display: block;
                    }
                }
                .txt-yh-t{
                    width: 101px;
                    height: 82px;
                    overflow: hidden;
                    position: absolute;
                    img{
                        width: 101px;
                        height: 82px;
                        display: block;
                    }
                }
            }
            .board-boss{
                position: absolute;
                width: 459px;
                height: 492px;
                overflow: hidden;
                left: 0;
                top: 75px;
                .boss-bg{
                    width: 459px;
                    height: 492px;
                    display: block;
                }
                .name-boss{
                    font-family: 'SourceHanSansCN-Regular';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 103px;
                    line-height: 90px;
                    font-size: 20px;
                    text-align: center;
                    color: #fff;
                    transition: all 1s;
                    opacity: 0;
                    .name-bg{
                        position: absolute;
                        bottom: 0;
                        width: 414px;
                        left: 29px;
                    }
                    p{
                        position: relative;
                        span{
                            margin-left: 10px;
                            font-size: 24px;
                            font-weight: bold;
                        }
                    }

                }
                .boss-hide{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 225px;
                    z-index: 2;
                }
                &:hover{
                    .name-boss{
                        opacity: 1;
                    }
                }
            }

        }
    }
</style>
